import React, { PropTypes } from 'react';
import { RaisedButton, FontIcon } from 'material-ui';
import { connect } from 'react-redux';
import { equals, isEmpty, either, isNil, propOr } from 'ramda';
import Buttons from './buttons';

const isNilOrEmpty = either(isNil, isEmpty);

const SelectMethod = props => {
  const {
    addPartnersMethod,
    updateMMPartnerProp,
    actionItems,
    MMPartnerReducer,
    isSupplier,
  } = props;

  return (
    <div style={{ marginTop: isSupplier ? '30px' : '10px' }}>
      How would you like to add partners? <br/><br/>
      Note: Sending your marketing materials to users not on TourConnect will generate a connection request. This feature is currently in beta.
      {actionItems.map(({ text, func, icon }, index) => (
        <div key={index} style={{ marginTop: equals(index, 0) ? '15px' : '' }}>
          <RaisedButton
            label={equals(text, 'Select from connections') && isNilOrEmpty(propOr([], 'existingConnections', MMPartnerReducer)) ? `${text} - You do not have any connections` : text}
            labelPosition="after"
            labelStyle={{ color: '#757575', fontSize: '14px', paddingLeft: '0px', marginLeft: '10px' }}
            style={{ marginTop: '1%', marginBottom: '1%' }}
            onTouchTap={func}
            disabled={equals(text, 'Select from connections') && isNilOrEmpty(propOr([], 'existingConnections', MMPartnerReducer))}
          >
            <FontIcon className={icon} style={{ color: '#757575', verticalAlign: 'middle', marginLeft: '10px' }} />
          </RaisedButton>
        </div>
      ))}
      <Buttons
        outerDivStyle={{ textAlign: 'right' }}
        objectInfoToMap={[
          {
            labelText: 'Cancel',
            labelStyle: { fontWeight: '600' },
            style: { marginRight: '20px' },
            onTouchTap: () => updateMMPartnerProp({ sendToPartners: false }),
          },
          {
            labelText: 'Next',
            labelStyle: { fontWeight: '600' },
            onTouchTap: () => updateMMPartnerProp({ sendToPartners: false }),
            disableButton: isEmpty(addPartnersMethod),
          },
        ]}
      />
    </div>
  );
};

SelectMethod.propTypes = {
  updateMMPartnerProp: PropTypes.func,
  addPartnersMethod: PropTypes.string,
  actionItems: PropTypes.array,
  MMPartnerReducer: PropTypes.object,
  isSupplier: PropTypes.bool,
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps)(SelectMethod);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/select-method.jsx